import { render, staticRenderFns } from "./peopleLibrary.vue?vue&type=template&id=fb43af58&scoped=true&"
import script from "./peopleLibrary.vue?vue&type=script&lang=js&"
export * from "./peopleLibrary.vue?vue&type=script&lang=js&"
import style0 from "./peopleLibrary.vue?vue&type=style&index=0&id=fb43af58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb43af58",
  null
  
)

export default component.exports